import { useMemo } from "react";
import { differenceInMinutes, format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { CalendarCheck } from "lucide-react";
import { trpc } from "@/lib/trpc";
import { Card, CardEmpty, CardLoading, Rodape, VerTodos } from "./QuadroBase";
import type { QuadroProps } from "./tipos";

/** Os últimos atendimentos concluídos do paciente, do mais recente pro mais antigo. */
export function QuadroAtendimentos({ patientId, menu, irParaAba }: QuadroProps) {
  const query = trpc.appointment.listByPatient.useQuery({ patientId, take: 30 });
  const atendidos = useMemo(
    () => ((query.data ?? []) as any[]).filter((a) => a.status === "COMPLETED").slice(0, 4),
    [query.data],
  );

  return (
    <Card icon={<CalendarCheck className="h-4 w-4" />} title="Últimos atendimentos" tone="emerald" menu={menu}>
      {query.isLoading ? (
        <CardLoading />
      ) : atendidos.length === 0 ? (
        <CardEmpty icon={<CalendarCheck className="h-6 w-6" />} text="Nenhum atendimento ainda" hint="Os atendimentos concluídos aparecerão aqui" />
      ) : (
        <ul className="space-y-2.5">
          {atendidos.map((a) => {
            const minutos = a.startedAt && a.finishedAt ? differenceInMinutes(new Date(a.finishedAt), new Date(a.startedAt)) : null;
            return (
              <li key={a.id} className="rounded-lg border border-zinc-100 bg-white p-2.5 dark:border-border dark:bg-card">
                <p className="truncate text-[11px] font-medium text-zinc-500 dark:text-muted-foreground">
                  {format(new Date(a.date), "EEE dd MMM yyyy", { locale: ptBR })}
                  {minutos !== null && minutos > 0 && ` · ${minutos} min`}
                </p>
                <p className="mt-0.5 truncate text-sm font-medium text-zinc-900 dark:text-foreground">{a.procedure || "Consulta"}</p>
                {a.dentistName && <p className="truncate text-[11px] text-zinc-500 dark:text-muted-foreground">{a.dentistName}</p>}
              </li>
            );
          })}
        </ul>
      )}
      <Rodape>
        <VerTodos rotulo="Ver histórico" onClick={() => irParaAba("historico")} />
        <span />
      </Rodape>
    </Card>
  );
}
